import { AxiosResponse } from 'axios';
import { axiosClient } from '../api/axiosClient';
import { ChangeRequestExportFormat } from '../enums/changeRequest';
import { Notify } from './notificationService';

const _getFileNameFromResponse = (
  response: AxiosResponse,
  _defaultFileName: string | undefined
) => {
  const defaultFileName = _defaultFileName || `Change_Request`;
  const dispositionHeader = response.headers['content-disposition'];
  if (!dispositionHeader) {
    return defaultFileName;
  }
  const match = dispositionHeader.match(/filename="?(.+?)"?$/);
  return match?.[1] || defaultFileName;
};

export const handleExportDoc = async (
  format: string,
  id: string,
  opts?: {
    depth?: string;
  }
) => {
  try {
    const apiUrlMap: Record<string, string> = {
      [ChangeRequestExportFormat.PDF]: `/cr/export/${id}/type/pdf`,
      [ChangeRequestExportFormat.DOCX]: `/cr/export/${id}/type/docx`,
      [ChangeRequestExportFormat.XLSX]: `/cr/export/${id}/type/xlsx`,
      [ChangeRequestExportFormat.JSON]: `/cr/export/${id}/type/json`,
    };

    const apiUrl = apiUrlMap[format];

    if (!apiUrl) {
      throw new Error('Invalid export format');
    }
    const response = await axiosClient({
      url: apiUrl,
      method: 'POST',
      responseType: 'arraybuffer',
      data: opts?.depth ? { depth: opts.depth } : undefined,
    });

    if (response?.data) {
      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const defaultFileName = `Change_Request.${format}`;
      const fileName = _getFileNameFromResponse(response, defaultFileName);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
      Notify.success('Exported successfully!');
    } else {
      throw new Error('No data received from the server.');
    }
  } catch (error) {
    Notify.error('An error occurred while exporting the file.');
  }
};
